<section class="hero-wrap hero-wrap-2" style="background-image: url('../../assets/images/bg_4.jpg');">
    <div class="overlay"></div>
    <div class="container">
        <div class="row no-gutters slider-text align-items-center justify-content-center">

        </div>
    </div>
</section>

<section class="ftco-section bg-light">
    <div class="container">
        <div class="row no-gutters justify-content-center">
            <div class="col-md-12">
                <div class="wrapper">
                    <div class="row d-flex justify-content-center g-0">
                        <div class="col-lg-6">
                            <div class="contact-wrap w-100 wrap-content">
                                <h3>
                                    Set Password
                                </h3>
                                <form [formGroup]="setPasswordForm" *ngIf="!isSubmitted">
                                    <div class="col-md-12 mt-3">
                                        <div class="form-group">
                                            <input type="password" class="form-control" name="new_password"
                                                placeholder="New Password" formControlName="password">
                                        </div>
                                        <ng-container *ngIf="myFormSubmit && setPasswordForm.value.password == ''">
                                            <div class="text-danger">
                                                New Password is required
                                            </div>
                                        </ng-container>
                                    </div>

                                    <div class="col-md-12 mt-3">
                                        <div class="form-group">
                                            <input type="password" class="form-control" name="confirm_password"
                                                placeholder="Confirm Password" formControlName="confirm_password">
                                        </div>
                                        <ng-container *ngIf="myFormSubmit && setPasswordForm.value.confirm_password == ''">
                                            <div class="text-danger">
                                                Confirm Password is required
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="myFormSubmit && setPasswordForm.value.confirm_password != setPasswordForm.value.password">
                                            <div class="text-danger">
                                                Passwords do not match
                                            </div>
                                        </ng-container>
                                    </div>

                                    <div class="col-md-12 mt-1">
                                        <div class="form-group">
                                            <button type="submit" class="btn btn-primary" (click)="onSubmit()">Submit</button>
                                        </div>
                                    </div>
                                </form>

                                <div *ngIf="isSubmitted" class="alert alert-success mt-3" role="alert">
                                    <p class="success-message">{{ successMessage }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
